"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ISurvey = require("../Api/ISurvey");
var CommentComponent = require("../SurveyComponents/CommentComponent");
var PromptComponent = require("../SurveyComponents/PromptComponent");
var RatingComponent = require("../SurveyComponents/RatingComponent");
var Utils = require("../Utils");
var Survey_1 = require("./Survey");
var SurveyDataSource = require("./SurveyDataSource");
var isNOU = Utils.isNOU,
  overrideValues = Utils.overrideValues;
var NlqsSurvey = /** @class */function (_super) {
  __extends(NlqsSurvey, _super);
  function NlqsSurvey(data) {
    var _this = _super.call(this) || this;
    if (isNOU(data)) {
      throw new Error("data must not be null");
    }
    _this.surveyInfo = new SurveyDataSource(data.baseData);
    _this.prompt = new PromptComponent(data.promptData);
    _this.question = new CommentComponent(data.commentData);
    _this.rating = new RatingComponent(data.ratingData);
    return _this;
  }
  NlqsSurvey.make = function (data) {
    try {
      return new NlqsSurvey(data);
    } catch (e) {
      return null;
    }
  };
  NlqsSurvey.makeNlqs = function (baseData, sp, surveyModel) {
    if (isNOU(baseData) || isNOU(sp) || isNOU(surveyModel)) {
      return null;
    }
    var ratingValuesAscending = [];
    var content = surveyModel.content;
    if (isNOU(content) || isNOU(content.comment) || isNOU(content.prompt) || isNOU(content.rating)) {
      return null;
    }
    var data = new NlqsSurvey.NlqsSurveyData();
    data.baseData = baseData;
    data.promptData = new PromptComponent.PromptComponentData();
    data.ratingData = new RatingComponent.RatingComponentData();
    data.commentData = new CommentComponent.CommentComponentData();
    data.promptData.title = sp.getCustomString(content.prompt.title);
    data.promptData.question = sp.getCustomString(content.prompt.question);
    data.promptData.yesButtonLabel = sp.getCustomString(content.prompt.yesLabel);
    data.promptData.noButtonLabel = sp.getCustomString(content.prompt.noLabel);
    data.ratingData.question = sp.getCustomString(content.rating.question);
    data.ratingData.isZeroBased = content.rating.isZeroBased;
    data.commentData.question = sp.getCustomString(content.comment.question);
    for (var _i = 0, _a = content.rating.ratingValuesAscending; _i < _a.length; _i++) {
      var value = _a[_i];
      var customString = sp.getCustomString(value);
      if (isNOU(customString)) {
        return null;
      }
      ratingValuesAscending.push(customString);
    }
    data.ratingData.ratingValuesAscending = ratingValuesAscending;
    if (isNOU(data.ratingData.question) || isNOU(data.commentData.question) || isNOU(data.promptData.title) || isNOU(data.promptData.question) || isNOU(data.promptData.yesButtonLabel) || isNOU(data.promptData.noButtonLabel) || isNOU(data.ratingData.ratingValuesAscending)) {
      return null;
    }
    return this.make(data);
  };
  // @Override
  NlqsSurvey.prototype.getType = function () {
    return ISurvey.Type.Nlqs;
  };
  // @Override
  NlqsSurvey.prototype.getSurveyInfo = function () {
    return this.surveyInfo;
  };
  // @Override
  NlqsSurvey.prototype.getCommentComponent = function () {
    return this.question;
  };
  // @Override
  NlqsSurvey.prototype.getPromptComponent = function () {
    return this.prompt;
  };
  // @Override
  NlqsSurvey.prototype.getRatingComponent = function () {
    return this.rating;
  };
  // @Override
  NlqsSurvey.prototype.getComponent = function (componentType) {
    switch (componentType) {
      case "Comment" /* Comment */:
        return this.getCommentComponent();
      case "Prompt" /* Prompt */:
        return this.getPromptComponent();
      case "Rating" /* Rating */:
        return this.getRatingComponent();
      default:
        return null;
    }
  };
  // @Override
  NlqsSurvey.prototype.getDomElements = function (doc) {
    if (isNOU(doc)) {
      throw new Error("Document must not be null");
    }
    var element = doc.createElement(ISurvey.DOM_NLQS_TAGNAME);
    this.getSurveyInfo().getDomElements(doc).forEach(function (child) {
      if (!isNOU(child)) {
        element.appendChild(child);
      }
    });
    this.getCommentComponent().getDomElements(doc).forEach(function (child) {
      if (!isNOU(child)) {
        element.appendChild(child);
      }
    });
    this.getRatingComponent().getDomElements(doc).forEach(function (child) {
      if (!isNOU(child)) {
        element.appendChild(child);
      }
    });
    return [element];
  };
  // @Override
  NlqsSurvey.prototype.getJsonElements = function () {
    var result = {};
    result = overrideValues(this.getSurveyInfo().getJsonElements(), result);
    result = overrideValues(this.getCommentComponent().getJsonElements(), result);
    result = overrideValues(this.getRatingComponent().getJsonElements(), result);
    return result;
  };
  return NlqsSurvey;
}(Survey_1.Survey);
(function (NlqsSurvey) {
  /**
   * Data required for a Nlqs Survey
   */
  var NlqsSurveyData = /** @class */function () {
    function NlqsSurveyData() {}
    return NlqsSurveyData;
  }();
  NlqsSurvey.NlqsSurveyData = NlqsSurveyData;
})(NlqsSurvey || (NlqsSurvey = {}));
module.exports = NlqsSurvey;